<template>
	<div class="plantorelease">
		<Nav ref="Nav"></Nav>
		<div class="writing_right">
			<div class="TitleList">
				<div class="TitleList_padding">
					<div class="TitleList_top">
						<div class="TitleList_top_title"><span></span>计划发布</div>
						<div class="TitleList_top_txt">
							<div class="top_txt_dt">
								<div class="txt_dt_list">
									<el-select clearable v-model="search.site_id" placeholder="所属站点">
										<el-option v-for="item in sites" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</div>
								<div class="txt_dt_list">
									<el-select clearable v-model="search.state" placeholder="状态">
										<el-option v-for="item in search.state_inc" :key="item.value" :label="item.name"
											:value="item.value">
										</el-option>
									</el-select>
								</div>
								<div class="txt_dt_search">
									<div class="dt_search_left">
										<span><i class="el-icon-search"></i></span>
										<input type="text" v-model="search.keywords" placeholder="任务名称" />
									</div>
									<div class="dt_search_right" @click="getList">搜索</div>
								</div>
							</div>
							<div class="TitleList_top_btn">
								<button @click="addPlan">添加计划</button>
							</div>
						</div>
					</div>
				</div>
				<div class="myarticles" v-loading="loading" element-loading-spinner="el-icon-loading"
					element-loading-text="拼命加载中" element-loading-background="rgba(255, 255, 255, 1)">
					<div class="myarticles_content creation">

						<div class="myarticles_padding" v-show="hasSelectedItems">
							<div class="myarticles_top">
								<div class="myarticles_top_left">已选择{{ selectedCount }}项</div>
								<div class="myarticles_top_right">
									<button class="top_right_list" @click="startSelected(1)"
										:disabled="!hasSelectedItems">批量启用</button>
									<button class="top_right_list" @click="startSelected(0)"
										:disabled="!hasSelectedItems">批量禁用</button>
									<button class="top_right_list" @click="setSelected"
										:disabled="!hasSelectedItems">批量设置</button>
									<button class="top_right_list" @click="deleteSelected"
										:disabled="!hasSelectedItems">批量删除</button>
									<div class="top_right_list" @click="cancelSelection">取消选择</div>
								</div>
							</div>
						</div>

						<div class="myarticles_content_title">
							<div class="content_title_list">
								<label><input type="checkbox" v-model="selectAll">序号</label>
							</div>
							<div class="content_title_list">任务名称</div>
							<div class="content_title_list">状态</div>
							<div class="content_title_list">周期</div>
							<div class="content_title_list">执行时间</div>
							<div class="content_title_list">站点</div>
							<div class="content_title_list">发送量</div>
							<div class="content_title_list">累计发送</div>
							<div class="content_title_list">操作</div>
						</div>
						<div class="myarticles_content_tab">
							<div class="content_tab_list" :class="{ on: info.checked }"
								v-for="(info, index) in infos.data" :key="index">
								<div class="tab_list_li">
									<label>
										<input type="checkbox" v-model="info.checked">
										{{ info.id }}
									</label>
								</div>
								<div class="tab_list_li">
									{{ info.name }}
									<span class="Insufficient" v-if="info.article_num < 20"><a
											:href="'#/writing/titleGeneration/BackgroundHostingCreate?article_class_id=' + info['article_class_id']"
											target="_blank" title="当前发布计划对应的文章库不足以支撑未来几天的发布任务,请您创建文章."> 文章库存不足
											[立即创建]</a></span>
								</div>
								<div class="tab_list_li">
									<div class="list_li_state" v-if="info.is_open == 1"><span></span>启用中</div>
									<div class="list_li_state on" v-if="info.is_open == 0"><span></span>已禁用</div>
								</div>
								<div class="tab_list_li">{{ info.period_str }}</div>
								<div class="tab_list_li">{{ info.time_str }}</div>
								<div class="tab_list_li">{{ info.site_name }}</div>
								<div class="tab_list_li">{{ info.number_of_articles }}</div>
								<div class="tab_list_li">{{ info.total }}</div>
								<div class="tab_list_li operate">
									<div class="list_li_btn" @click="editor(index)"><img src="@a/img/sv5.svg" />编辑</div>
									<div class="list_li_btn" @click="deleteInfo(index)"><img src="@a/img/sv6.svg" />删除
									</div>
									<div class="list_li_btn" @click="openNewWindow(info.id)"><img
											src="@a/img/sv11.svg" />日志</div>
								</div>
							</div>
							<div class="not_data not_data2" v-show="infos.data.length === 0">
								<div class="not_data_icon"><img src="@a/img/bg26.jpg" /></div>
								<div class="not_data_title">暂无发布计划</div>
							</div>
						</div>
					</div>
					<div class="page">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="infos.current_page" :page-sizes="per_pages" :page-size="infos.per_page"
							layout="total, sizes, prev, pager, next, jumper" :total="infos.total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>

		<!-- 批量设置 -->
		<div class="Preview Edit" v-show="showBatchSettings">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>批量设置</div>
					<div class="content_title_right" @click="showBatchSettings = !showBatchSettings"><i
							class="el-icon-close"></i>
					</div>
				</div>
				<div class="Edit_content ovauto" style="max-height: 600px;overflow: auto; padding-right: 10px;">
					<div class="Edit_content_list">
						<div class="content_list_dd">
							文章数量
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-input placeholder="发布文章数量" v-model="sets.number_of_articles" clearable>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list paddleft">
						<div class="content_list_dd">
							是否启用
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<div class="radio">
								<el-radio v-model="sets.is_open" label="1">启用</el-radio>
								<el-radio v-model="sets.is_open" label="0">禁用</el-radio>
							</div>
						</div>
					</div>
				</div>
				<div class="Edit_btn">
					<button class="back" @click="showBatchSettings = !showBatchSettings">返回</button>
					<button class="save" @click="setsSave">批量设置</button>
				</div>
			</div>
		</div>


		<!-- 添加计划 -->
		<div class="Preview Edit" v-show="showPreview">
			<div class="Preview_content">
				<div class="Preview_content_title">
					<div class="content_title_left"><span></span>添加计划</div>
					<div class="content_title_right" @click="showPreview = !showPreview"><i class="el-icon-close"></i>
					</div>
				</div>
				<div class="Edit_content ovauto" style="max-height: 600px;overflow: auto; padding-right: 10px;">
					<div class="Edit_content_list">
						<div class="content_list_dd">
							计划名称
							<el-tooltip class="item" effect="dark" content="计划名称,可以方便你识别不同的计划" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-input placeholder=" 如AI dog写作官网" v-model="plan.name" clearable>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							文章数量
							<el-tooltip class="item" effect="dark" content="每天或者每周要发布的文章数量,请输入数字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-input placeholder="发布文章数量" v-model="plan.number_of_articles" clearable>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list paddleft">
						<div class="content_list_dd">
							是否启用
							<el-tooltip class="item" effect="dark" content="只要开启的计划才会自动发布" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<div class="radio">
								<el-radio v-model="plan.is_open" label="1">启用</el-radio>
								<el-radio v-model="plan.is_open" label="0">禁用</el-radio>
							</div>
						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							文章分类
							<el-tooltip class="item" effect="dark" content="选择从哪个文章分类里发布文章" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-select v-model="plan.article_class_id" placeholder="请选择文章分类">
								<el-option v-for="item in class_types" :key="item.id"
									:label="item.name + '(' + item.count + ')'" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="Edit_content_list paddleft martop">
						<div class="content_list_dd">
							插入图片
							<el-tooltip class="item" effect="dark" content="系统在发布文章的时候可以插入图片,丰富文章内容." placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<div class="radio" style="padding-left: 0;">
								<el-checkbox v-model="plan.is_insert_picture"
									:disabled="isImageDisabled">插入图片</el-checkbox>
								<span v-if="isImageDisabled" @click="triggerChildMethod"
									style="color: blue; cursor: pointer; margin-left: 10px;">
									需要开通会员可解锁此功能
								</span>
							</div>
							<el-select v-model="plan.img_class_id" placeholder="请选择图片分类"
								v-show="plan.is_insert_picture">
								<el-option v-for="item in img_classes" :key="item.id" :label="item.name_all"
									:disabled="item.count == 0 ? true : false" :value="item.id">
								</el-option>
							</el-select>

							<div style="padding-top: 10px;" v-show="plan.is_insert_picture">
								<span
									style="font-size: 13px; color:#606266; padding-left:10px; margin-bottom: 5px; display: block;">插入位置</span>
								<el-select v-model="plan.img_line" placeholder="图片插入位置">
									<el-option v-for="item in img_line_inc" :label="item.name" :value="item.value">
									</el-option>
								</el-select>
							</div>

						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							文章开头插入
							<el-tooltip class="item" effect="dark" content="计划执行发布的时候会在文章开头部分插入相应的内容,支持html代码." placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-input type="textarea" rows="5" placeholder="文章开头插入的内容,支持html代码" v-model="plan.insert_before" clearable>
							</el-input>
						</div>
					</div>					
					<div class="Edit_content_list">
						<div class="content_list_dd">
							文章结尾插入
							<el-tooltip class="item" effect="dark" content="计划执行发布的时候会在文章结尾部分插入相应的内容,支持html代码." placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-input type="textarea" rows="5" placeholder="文章结尾插入的内容,支持html代码" v-model="plan.insert_end" clearable>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list paddleft martop">
						<div class="content_list_dd">
							SEO链轮
							<el-tooltip class="item" effect="dark" content="点击查看使用方法" placement="top-start">
								<el-button><a href="https://www.ai-dog.net/help/ruanwen/13.html" target="_blank"><img
											src="@a/img/sv12.svg" /></a></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-checkbox v-model="plan.is_relation" :disabled="isUrlDisabled"
								style="margin-bottom: 5px;">开启文章关联</el-checkbox>
							<span v-if="isImageDisabled" @click="triggerChildMethod"
								style="color: blue; cursor: pointer; margin-left: 10px;">
								需要开通会员可解锁此功能
							</span>
							<div class="list_dt_slider" v-show="plan.is_relation"
								style="align-items: center; font-size: 13px; color: #474b5a; justify-content: space-between; align-items: center; padding-right: 10px;">
								<div style="font-size: 13px; color: #474b5a; margin-top: 10px; ">
									相关文章条数：在{{ plan.relation_num }}之间</div>

								<div style="width: calc(100% - 105px);">
									<el-slider v-model="plan.relation_num" range show-stops show-tooltip :min="1"
										:max="10">
									</el-slider>
								</div>
							</div>
							<span style="font-size: 13px; color: #474b5a;margin-bottom: 10px; display: inline-block;"
								v-show="plan.is_relation">自定义相关文章标题</span>
							<el-input v-model="plan.relation_title" v-show="plan.is_relation" placeholder=""></el-input>
							<div style="font-size: 13px; color: #999; margin-top: 10px;" v-show="plan.is_relation">
								标题中必须包含[keywords]关键词，具体见<a href="https://www.ai-dog.net/help/ruanwen/13.html"
									target="_blank">“帮助中心”</a></div>
						</div>
					</div>

					<div class="Edit_content_list time">
						<div class="content_list_dd">
							执行周期
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt" style="justify-content: flex-start">
							<el-select v-model="plan.period" placeholder="发布周期">
								<el-option v-for="item in periods" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
							<el-input v-if="plan.period == 3" class="list_dt_input" placeholder="" v-model="plan.day">
								<template slot="append">日</template>
							</el-input>
							<el-select class="week" v-if="plan.period == 2" v-model="plan.week" placeholder="每周星期几"
								multiple filterable>
								<el-option v-for="item in weeks" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>

						</div>
					</div>

					<div class="Edit_content_list time">
						<div class="content_list_dd">
							执行时间
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt" style="justify-content: flex-start">

							<el-input class="list_dt_input" placeholder="" v-model="plan.hour">
								<template slot="append">小时</template>
							</el-input>
							<el-input class="list_dt_input" placeholder="" v-model="plan.minute">
								<template slot="append">分钟</template>
							</el-input>
						</div>
					</div>
					<div class="Edit_content_list time martop">
						<div class="content_list_dd" style="padding-top: 12px;">
							发送间隔
							<el-tooltip class="item" effect="dark" content="会随机在这个间隔区间生成一个随机数分钟" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt" style="justify-content: flex-start; flex-wrap: wrap;">
							<div style="clear: both; display: block; width: 100%;">
								<el-input class="list_dt_input" placeholder="" v-model="plan.time_gap">
									<template slot="append">分钟</template>
								</el-input>
							</div>
							<div style="font-size: 13px; color: #999; margin-top: 10px; clear: both; line-height: 1.3;">
								例如填写"1-10"每篇文章发送的间隔时间会在1-10生成一个随机数,<br>例如填写一个固定的数"5"，发送频率就是固定5分钟</div>
						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							选择站点
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-select v-model="plan.site_id" placeholder="请选择站点" @change="changeSite">
								<el-option v-for="item in sites" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
					<div class="Edit_content_list">
						<div class="content_list_dd">
							站点栏目
							<el-tooltip class="item" effect="dark" content="Top Left 提示文字" placement="top-start">
								<el-button><img src="@a/img/sv12.svg" /></el-button>
							</el-tooltip>
						</div>
						<div class="content_list_dt">
							<el-select v-model="plan.site_cat_id" placeholder="请选择站点栏目">
								<el-option v-for="item in site_classes" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</div>
					</div>
				</div>
				<div class="Edit_btn">
					<button class="back" @click="showPreview = false">返回</button>
					<button class="save" @click="save">提交保存</button>
				</div>
			</div>
		</div>


	</div>
</template>

<script>
import Nav from "@c/common/nav/nav";
import {
	MessageBox,
	Message
} from 'element-ui';

export default {
	name: "plantorelease",
	data() {
		return {
			//文章配图是否能勾选
			isImageDisabled: true,
			//seo链轮是否能勾选
			isUrlDisabled: true,
			plan: {
				name: '',
				article_class_id: '',
				img_class_id: '',
				site_id: '',
				site_cat_id: '',
				is_insert_picture: false,
				img_line: 1,
				insert_before: '',
				insert_end: '',
				is_relation: false,
				relation_num: [4, 6],
				relation_title: "更多和<b>”[keywords]“</b>相关的文章",
				minute: '',
				hour: '',
				day: '',
				month: '',
				week: '',
				number_of_articles: '20',
				time_gap: "1-10", //发送时间间隔
				is_open: '1',
				period: 1
			},
			//批量设置
			sets: {
				number_of_articles: "",
				is_open: ""
			},
			search: {
				site_id: '',
				state: '',
				state_inc: [{
					name: "开启",
					value: 1
				},
				{
					name: "禁用",
					value: 0
				},
				],
				keywords: '',
			},
			img_line_inc: [{
				name: "随机",
				value: 0
			},
			{
				name: "第一段前",
				value: 1
			},
			{
				name: "第二段前",
				value: 2
			},
			{
				name: "第三段前",
				value: 3
			},
			{
				name: "第四段前",
				value: 4
			},
			{
				name: "第五段前",
				value: 5
			},
			{
				name: "第六段前",
				value: 6
			},
			{
				name: "文章结束",
				value: 100
			},
			],
			weeks: [{
				value: 1,
				label: '周一'
			},
			{
				value: 2,
				label: '周二'
			},
			{
				value: 3,
				label: '周三'
			},
			{
				value: 4,
				label: '周四'
			},
			{
				value: 5,
				label: '周五'
			},
			{
				value: 6,
				label: '周六'
			},
			{
				value: 7,
				label: '周日'
			},
			],

			periods: [{
				id: 1,
				name: '每天'
			},
			{
				id: 2,
				name: '每周'
			},
			{
				id: 3,
				name: '每月'
			},

			],
			sites: [],
			site_classes: [],
			img_classes: [],
			class_types: [],
			isChecked: false,
			showPreview: false,
			showBatchSettings: false,
			infos: {
				data: [],
				per_page: 20,
				current_page: 1,
				last_page: 1,
				total: 0
			},
			is_editor: false,
			//selectAll: false, // 全选状态，默认为false
			per_pages: [20, 50, 100],
			loading: true,
		};
	},
	components: {
		Nav
	},
	created() {
		this.getArticleClass()
		this.getSites()
		this.getImgClass()
		this.getList()
		this.getMemberStatus()
	},
	computed: {
		//获取会员状态
		getMemberStatus() {
			this.axios.get('api/Seo/memberImageStatus')
				.then(response => {
					if (response.code == 1) {
						this.isImageDisabled = false;
					} else {
						this.isImageDisabled = true;
					}
				})
				.catch(error => {
					console.error(error); // 处理错误
				});

			//seo链轮
			this.axios.get('api/Seo/memberChainStatus')
				.then(response => {
					if (response.code == 1) {
						this.isUrlDisabled = false;
					} else {
						this.isUrlDisabled = true;
					}
				})
				.catch(error => {
					console.error(error); // 处理错误
				});


		},
		//全选
		selectAll: {
			get() {
				return this.infos.data.every(info => info.checked)
			},
			set(value) {
				this.infos.data.forEach(info => {
					info.checked = value;
					this.$set(info, 'checked', value); // 手动触发更新
				})
			},
		},
		selectedCount() {
			return this.infos.data.filter(info => info.checked).length
		},
		allCount() {
			return this.infos.data.filter(info => info).length
		},
		hasSelectedItems() {
			return this.infos.data.filter(info => info.checked).length > 0;
		},
	},
	methods: {
		//点击触发ai套餐
		triggerChildMethod() {
			this.$refs.Nav.childMethod();
		},
		selectAllItems() {
			// 更新所有子复选框的选中状态为全选按钮的状态
			this.infos.data.forEach((info) => {
				info.checked = this.selectAll;
			});
		},
		checkSelectAll() {
			// 检查是否所有子复选框都选中
			this.selectAll = this.infos.data.every((info) => info.checked);
		},
		//取消选择
		cancelSelection() {
			this.selectAll = false;
		},
		//批量删除
		deleteSelected() {
			// 找出所有选中的项的索引
			const selectedIndexes = this.infos.data
				.map((info, index) => (info.checked ? index : null))
				.filter((index) => index !== null);
			let ids = []
			// 用户点击了确定按钮，执行删除操作
			for (let i = 0; i < selectedIndexes.length; i++) {
				var choice_index = selectedIndexes[i]
				var id = this.infos.data[choice_index].id
				ids.push(id);

			}
			MessageBox.confirm(`确定删除信息吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/api/plan/deletes', {
					ids: ids,
				}).then(res => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					});
					this.getList()
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
				// 用户点击取消或者弹窗关闭时不做任何操作
			});
		},
		setsSave() {
			// 找出所有选中的项的索引
			const selectedIndexes = this.infos.data
				.map((info, index) => (info.checked ? index : null))
				.filter((index) => index !== null);
			let ids = []
			// 用户点击了确定按钮，执行删除操作
			for (let i = 0; i < selectedIndexes.length; i++) {
				var choice_index = selectedIndexes[i]
				var id = this.infos.data[choice_index].id
				ids.push(id);

			}
			this.axios.post('/api/plan/sets', {
				ids: ids,
				number_of_articles: this.sets.number_of_articles,
				is_open: this.sets.is_open,
			}).then(res => {
				if (res.code === 1) {
					this.$message({
						type: 'success',
						message: '批量设置成功!'
					});
					this.getList();
					this.showBatchSettings = false;
				}

			})
		},
		//批量开启
		startSelected(is_open) {
			// 找出所有选中的项的索引
			const selectedIndexes = this.infos.data
				.map((info, index) => (info.checked ? index : null))
				.filter((index) => index !== null);
			let ids = []
			// 用户点击了确定按钮，执行删除操作
			for (let i = 0; i < selectedIndexes.length; i++) {
				var choice_index = selectedIndexes[i]
				var id = this.infos.data[choice_index].id
				ids.push(id);

			}
			MessageBox.confirm(`确定要批量操作吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.axios.post('/api/plan/start', {
					ids: ids,
					is_open: is_open
				}).then(res => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					});
					this.getList()
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消操作'
				});
				// 用户点击取消或者弹窗关闭时不做任何操作
			});
		},
		//批量关闭
		stopSelected() {
			MessageBox.confirm(`确定要批量停止吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				that.axios.post('/api/plan/stop', {
					id: item.id
				}).then(res => {
					that.$message({
						type: 'success',
						message: '操作成功!'
					});
					that.getList()
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '取消操作'
				});
				// 用户点击取消或者弹窗关闭时不做任何操作
			});
		},
		//批量设置
		setSelected() {
			this.showBatchSettings = true;
		},

		handleSizeChange(val) {
			this.infos.per_page = val
			this.getList()
		},
		handleCurrentChange(val) {
			this.infos.current_page = val
			this.getList()

		},
		async editor(index) {


			this.is_editor = true;
			let plan = this.infos.data[index];
			let that = this;
			that.axios.post('/api/plan/getContent', {
				id: plan.id
			}).then(
				res => {
					if (res.code === 1) {
						res.result.is_open = res.result.is_open == 1 ? '1' : '0';
						res.result.is_insert_picture = res.result.is_insert_picture == 1 ? true : false;
						res.result.is_relation = res.result.is_relation == 1 ? true : false;
						that.plan = res.result;


						this.axios.post('/api/site/getClassesById', {
							id: this.plan.site_id
						}).then(res => {
							that.site_classes = res.result
						})

						this.showPreview = true;
					}
				}
			)
		},

		async addPlan() {

			try {
				const res = await this.axios.get('api/Seo/memberPlanStatus');

				if (res.code === 1) {
					// 可以继续创建计划
					this.is_editor = false;
					this.showPreview = true;
					this.plan = {
						name: '',
						article_class_id: this.class_types[0].id,
						img_class_id: null,
						site_id: '',
						site_cat_id: '',
						is_insert_picture: false,
						img_line: 1,
						is_relation: false,
						relation_num: [4, 6],
						relation_title: "更多和<b>”[keyword]“</b>相关的文章",
						minute: Math.floor(Math.random() * 59) + 1,
						hour: Math.floor(Math.random() * 14),
						day: '',
						month: '',
						week: '',
						number_of_articles: 20,
						time_gap: "1-10", //发送时间间隔
						is_open: '1',
						period: 1
					};



				} else {
					// code为0时，不能创建计划，弹出充值弹窗
					this.$refs.Nav.childMethod();
				}
			} catch (error) {
				console.error('请求站点状态时出错:', error);
			}

		},

		back() {
			this.showPreview = true
		},
		save() {
			let that = this;
			let url = '/api/plan/add'
			if (this.is_editor) {
				url = '/api/plan/update'
			}
			that.axios.post(url, this.plan).then(
				res => {
					if (res.code === 1) {
						if (this.is_editor) {
							Message.success('更新计划成功')
						} else {
							Message.success('添加计划成功')
						}
						that.showPreview = false;
						this.getList()
					}
				}
			)
		},
		getList() {
			// loading 开始
			this.loading = true;
			let that = this;
			that.axios.get('/api/plan/list', {
				params: {
					page: that.infos.current_page,
					keywords: that.search.keywords,
					list_rows: that.infos.per_page,
					site_id: that.search.site_id,
					state: that.search.state
				}
			}).then(res => {
				// loading结束
				this.loading = false;
				res.result.data.forEach(res => {
					res.checked = false;
				})
				that.infos = res.result;
			})
		},
		getImgClass() {
			let that = this;
			this.axios.get('/api/imgClass/list').then(res => {
				res.result.forEach(item => {
					item.isActive = false
				})
				that.img_classes = res.result
			})
		},
		getArticleClass() {
			let that = this;
			this.axios.get('/api/articleClass/list').then(res => {
				res.result.forEach(item => {
					item.isActive = false
				})
				that.class_types = res.result
			})
		},

		changeSite(val) {
			this.getSiteClasses()
		},

		getSiteClasses() {
			let that = this;
			this.axios.post('/api/site/getClassesById', {
				id: this.plan.site_id
			}).then(res => {
				res.result.forEach(item => {
					item.isActive = false
				})
				that.site_classes = res.result
			})
		},

		getSites() {
			let that = this;
			this.axios.get('/api/site/list').then(res => {
				res.result.data.forEach(item => {
					item.isActive = false
				})
				that.sites = res.result.data
			})
		},
		//新窗口打开
		openNewWindow(id) {
			window.open('#/writing/releaselog?push_plan_id=' + id, '_blank', 'noopener');
		},
		//删除
		deleteInfo(index) {
			let that = this;
			const item = this.infos.data[index];
			MessageBox.confirm(`确定删除${item.name}吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				that.axios.post('/api/plan/delete', {
					id: item.id
				}).then(res => {
					that.$message({
						type: 'success',
						message: '删除成功!'
					});
					that.getList()
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
				// 用户点击取消或者弹窗关闭时不做任何操作
			});
		},
	},
	mounted() {

	},
}
</script>

<style>
@import "planTorelease.css";
</style>